import React from "react";
import frame2Image from "../../images/Frame2.png";
import { useNavigate } from "react-router";
import { UPLOAD_URL2 } from "../../config/constants/api";

const FALLBACK_THUMB =
  "https://reputationtoday.in/wp-content/uploads/2020/04/4d8dd-students-in-community.001.png";

export default function Card({ post }) {
  const navigate = useNavigate();

  const goToPost = () => navigate(`/community-post/${post?._id}`);

  const thumbSrc = post?.thumbnail
    ? `${UPLOAD_URL2}${post.thumbnail}`
    : FALLBACK_THUMB;

  const desc = post?.description || "";
  const excerptHtml = desc.slice(0, 110) + (desc.length > 30 ? " ......" : "");

  return (
    <article
      className="community-post-card"
      onClick={goToPost}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          goToPost();
        }
      }}
      role="link"
      tabIndex={0}
      aria-label={post?.title ? `Open discussion: ${post.title}` : "Open discussion"}
    >
      <div className="community-post-card__media">
        <img
          src={thumbSrc}
          alt=""
          className="community-post-card__thumb"
          loading="lazy"
        />
        <div className="community-post-card__media-shade" aria-hidden />
      </div>

      <div className="community-post-card__body">
        <div className="community-post-card__headline">
          <img src={frame2Image} alt="" className="community-post-card__avatar" />
          <h2 className="community-post-card__title">{post?.title}</h2>
        </div>
        <div
          className="community-post-card__excerpt"
          dangerouslySetInnerHTML={{ __html: excerptHtml }}
        />
      </div>

      <div className="community-post-card__footer">
        <span className="community-post-card__status" aria-hidden />
        <p className="community-post-card__author">{post?.name}</p>
        <p className="community-post-card__members">
          {(post?.members?.length ?? 0)}{" "}
          {(post?.members?.length ?? 0) > 1 ? "members" : "member"}
        </p>
      </div>
    </article>
  );
}
